import AxiosUtil from '../utils/axiosUtil';
import { BaseService } from './BaseService';

export const CustomerCompanyService = (function () {
  let instance;
  const BASE_URI = '/apis/customers/companies';
  const baseService = BaseService.getInstance(BASE_URI, 'customerCompany');

  function init() {
    return {
      ...baseService,
      register: async function (data) {
        return await AxiosUtil.Async.post(BASE_URI, data);
      },
      update: async function (data) {
        return await AxiosUtil.Async.put(BASE_URI, data);
      },
      list: async function (params) {
        const queryString = Object.entries(params)
          .map((e) => e.join('='))
          .join('&');
        return await AxiosUtil.Async.get(BASE_URI, queryString);
      },
      getData: async function (customerCompanyId) {
        return await AxiosUtil.Async.get(BASE_URI + `/${customerCompanyId}`);
      },
      delete: async function (customerCompanyId) {
        return await AxiosUtil.Async.delete(BASE_URI + `/${customerCompanyId}`);
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
